/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { updatePlayer } from "../../multiplayer/SocketConnection";
import store from "../../store/store";

const AFRAME = window.AFRAME;

export const PlayerCamera = () => {
    if (!AFRAME.components["player-camera"]) AFRAME.registerComponent("player-camera", {
        init: function () {
            this.existingRoom = store.getState().room.participants.length > 0
            if (!this.existingRoom)
                this.el.removeAttribute("right-hand");

            this.tick = AFRAME.utils.throttleTick(this.tick, 20, this);
            this.camera = document.querySelector("a-camera");
            this.position = {};
            this.rotation = {};
        },
        tick: function () {
            if (this.existingRoom) {
                const position = { ...this.camera.object3D.position };
                const rotation = { ...this.camera.object3D.rotation };
                let update = false;
                if (
                    this.position &&
                    (!this.inRange(this.position.x, position.x) ||
                        !this.inRange(this.position.y, position.y) ||
                        !this.inRange(this.position.z, position.z))
                ) {
                    this.position = position;
                    update = true;
                }
                if (
                    this.rotation &&
                    (!this.inRange(this.rotation._x, rotation._x) ||
                        !this.inRange(this.rotation._y, rotation._y) ||
                        !this.inRange(this.rotation._z, rotation._z))
                ) {
                    this.rotation = rotation;
                    update = true;
                }
                if (update) updatePlayer(this.position, this.rotation)
            }
        },
        inRange: function (x, target) {
            return Math.abs(Math.abs(x) - Math.abs(target)) <= 0.05;
        },
    });
}
